<div class="main-view space-y-2 md:space-y-4">
  <app-page-surface-header
    titleIcon="clipboard"
    title="Products"
    subtitle="Products this platform offers. Open a product to choose which documents it collects."
  />

  @if (error()) {
  <div
    class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-900/40 dark:bg-red-900/20 dark:text-red-300"
    role="alert"
  >
    {{ error() }}
  </div>
  }

  <app-list-module-surface
    [config]="listSurfaceConfig"
    [filters]="listFilters"
    [errorMessage]="''"
    [loading]="loading()"
    [meta]="paginationMeta"
    [rowCount]="pagedRecords.length"
    (filtersChange)="onListFiltersChange($event)"
    (pageChange)="onListPageChange($event)"
  >
    <app-list-module-table
      listTable
      variant="surface"
      [columns]="columns"
      [rows]="pagedRecords"
      [loading]="loading()"
      [emptyMessage]="emptyMessage"
      rowTrackKey="id"
    >
      <ng-template listCellDef="name" let-row="row">
        <span class="text-gray-900 dark:text-white">{{ row.name }}</span>
      </ng-template>

      <ng-template listCellDef="slug" let-row="row">
        <span class="font-mono text-xs text-gray-900 dark:text-white">{{ row.slug }}</span>
      </ng-template>

      <ng-template listCellDef="actions" let-row="row">
        <div class="inline-flex items-center justify-end gap-1">
          <a
            class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-primary hover:bg-primary/10"
            [routerLink]="['/products', row.slug, 'documents']"
            title="Manage documents"
            aria-label="Manage documents"
          >
            <icon-file class="h-4 w-4" />
          </a>
        </div>
      </ng-template>
    </app-list-module-table>
  </app-list-module-surface>
</div>
